/* template */
<template minapp="mpx" xlang="wxml"><div class="train-agreement"><div :style="[({marginTop: pickerMargin})] | transRpxStyle" class="picker-content"><div slot="left"><div class="picker-left">时间选择</div></div><div slot="right"><mpx-view @tap="pickerToggle" class="picker-right"><span>{{currentPickerLable}}</span><es-icon :name="(pickerOpen == true ? 'angle-top' : 'angle-down')" color="#999" size="14"/></mpx-view></div></div><div class="picker-select" v-if="(pickerOpen == true)"><div v-for="(item, index) in (pickerSelectOptions)" :key="item.index" class="item"><mpx-text :class="(item.label == currentPickerLable ? 'active-text' : '')" @tap="pickerSelect(item)">{{item.label}}</mpx-text></div></div><div v-show="(overlayShow)" class="picker-overlay"></div><div v-for="(item, index) in (personalInfoChecklist)" :key="item.index" class="agreement-content"><div class="title"><div class="title-left">{{item.title}}</div><mpx-view @tap="contentToggle(index)" class="title-right"><span>{{item.show == true ? '点击收起' : '点击展开'}}</span><es-icon :name="(item.show == true ? 'angle-top' : 'angle-down')" color="#999" size="14"/></mpx-view></div><div v-for="(subItem, index) in (item.sub_group)" :key="subItem.index" class="content" v-if="(item.show == true)"><div class="subtitle">{{subItem.subtitle}}</div><div v-for="(textItem, index) in (subItem.text_list)" class="content-item">{{textItem.key}}：<mpx-text :class="(textItem.jump_url ? 'go-order' : '')" @tap="jumpToOrder(textItem.jump_url)">{{textItem.value}}</mpx-text></div></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mf9de5df4"}'>
  .train-agreement
    position relative
    height 100%
    overflow-y scroll
    background-color rgb(243, 244, 245)
    .es-header
      margin-bottom 10px
    .es-navbar__title
      font-size 16px
    .agreement-content
      padding 16px
      background-color #fff
      margin-top 12px
      .title 
        display flex
        justify-content space-between
        align-items center
        .title-left
          font-family PingFangSC-Medium
          font-size 15px
          color #000
          font-weight 700
        .title-right
          font-size 12px
          color #999
          display flex 
          align-items center  
      .content 
        &:not(:last-child)
          padding-bottom 16px
          border-bottom 1px solid #ecedf0
        .subtitle
          margin 16px 0 4.5px 0
          color #444
          font-size 14px 
          font-weight 700
        .content-item
          font-size 12px
          color #999
          .go-order
            color #ff7c46
    .picker-overlay
      width 100%
      height 100%
      min-height 100vh
      background rgba(0,0,0,.4)
      position fixed
      top 55px
      left 0
      right 0
      bottom 0
      z-index 999
    .picker-content
      height 25px
      background-color #fff
      display flex
      justify-content space-between
      align-items center
      padding 15px
      .picker-left
        font-family PingFangSC-Medium
        font-size 15px
        color #000
        font-weight 700
      .picker-right
        font-size 12px
        color #999
        display flex 
        align-items center  
    .picker-select
      position fixed
      z-index 1000
      width 100%
      background-color #fff
      border-top 1px solid #f3f4f5
      left 0
      top 55px
      .item
        padding 16px
        border-bottom 1px solid #f3f4f5
        display flex
        justify-content center
        align-items center
        span 
          font-family PingFangSC-Medium
          font-size 14px
          color #757575
          font-weight 500
          text-align center
        .active-text
          color #ea5e1e
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mf9de5df4"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["mf9de5df4"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"component":true},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-navbar':getComponent(require("../../es-mpx-ui/lib/navbar/index.mpx?isComponent&outputPath=components%2Findex2c95552b%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-text':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-text.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
